var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.viewBannerCountry)?_c('div',{staticClass:"countires-banner__container"},_vm._l((_vm.infoCurrentCountry),function(infoBlock,index){return _c('country-info',{key:index,attrs:{"dataInfoCountry":infoBlock}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }